import { stringifyCookie } from './stringifyCookies';

import type * as cookie from 'cookie';

/**
 * Set-Cookie 헤더 문자열을 생성합니다.
 * @description
 * - 기본적으로 Path=/, HttpOnly=true를 적용합니다.
 * @example
 * // createSetCookieString('KC_AUT', 'token')
 */
export const createSetCookieString = (
  name: string,
  value: string,
  options?: cookie.SerializeOptions,
): string => {
  const { path, httpOnly, ...restOptions } = options ?? {};

  return stringifyCookie(name, value, {
    ...restOptions,
    path: path || '/',
    httpOnly: httpOnly ?? true,
  });
};
